// ╔═══════════════════════════════════════════════════════════════════════════╗
// ║              MODELLO CONFIGURAZIONE TENANT — NUOVO RISTORANTE              ║
// ╠═══════════════════════════════════════════════════════════════════════════╣
// ║  Questo file è un TEMPLATE. NON è importato dall'app.                       ║
// ║  Per accendere un nuovo ristorante:                                        ║
// ║    1. copia questo file su  src/tenant.config.js  (sovrascrivi)            ║
// ║    2. compila TUTTI i campi qui sotto con i valori del nuovo ristorante    ║
// ║    3. usa storageKey / idbDbName DIVERSI da qualsiasi altro ristorante     ║
// ║       (isolamento fisico: nessun dato condiviso tra istanze)               ║
// ║  Vedi docs/NUOVO_RISTORANTE.md per la checklist completa.                  ║
// ╚═══════════════════════════════════════════════════════════════════════════╝

export const TENANT = {
  // Identità logica: un nuovo id/restaurantId per ogni ristorante (es. "t1"/"r1").
  // Compaiono nei record CRM/Floor come tenantId/restaurantId.
  id: "t1",
  restaurantId: "r1",

  // Nome commerciale e città del nuovo ristorante — appaiono nelle etichette UI,
  // nelle stampe e nel profilo ristorante.
  name: "Ristorante Prova",
  city: "Ancona",

  // Logo a due righe in cima alla sidebar. Personalizza con il nome del locale.
  logo: { line1: "Ristorante", line2: "Prova" },

  // Identità fiscale / di stampa (ragione sociale, insegna, indirizzo completo).
  // Fanno da ripiego su stampe e registri (mensa, scontrino termico) FINCHÉ non
  // imposti i dati reali da Impostazioni. Se ometti un campo, il codice ricade
  // sul default storico di Bottega: per un nuovo ristorante compilali sempre.
  companyName: "Ristorante Prova",     // ragione sociale
  insegna: "RISTORANTE PROVA",         // insegna commerciale (stampe registro mensa)
  companyAddress: "Ancona",            // indirizzo/sede sintetico
  agendaBrand: "Ristorante Prova",     // marchio in cima alla Modalità Accoglienza

  // Sottotitoli di STABILIMENTO per i template di stampa a valenza legale.
  // Identificano l'operatore/laboratorio (Reg. CE 852/2004, Reg. CE 178/2002 art. 18).
  //   traceLabelSubline    : riga BREVE sull'etichetta di tracciabilità lotto
  //                          (rotolo termico 62mm — niente a capo: località + sigle).
  //   haccpRegistrySubline : riga ESTESA nell'intestazione del registro HACCP A4.
  traceLabelSubline: "LABORATORIO ANCONA · AN · IT",
  haccpRegistrySubline: "LABORATORIO ARTIGIANALE · ANCONA (AN) · ITALIA",

  // Profilo del SEED iniziale:
  //   "bottega" = seed pieno di Bottega (NON usare per un nuovo ristorante).
  //   "blank"   = seed VUOTO — un nuovo ristorante parte pulito e configura da sé
  //               fornitori, prodotti-base e aree sala dall'app. Lascia "blank".
  seedProfile: "blank",

  // ── CHIAVI DATI FISICHE — DEVONO ESSERE UNICHE PER QUESTO RISTORANTE ───────
  // Convenzione: voya_<slug>_v1  /  voya_<slug>_db  (slug = nome breve del locale).
  // Cambiarle DOPO il primo avvio in produzione = perdita dati: sceglile una volta.
  storageKey: "voya_prova_v1",  // chiave localStorage + record IndexedDB stato
  idbDbName: "voya_prova_db",    // nome database IndexedDB (store "kv")

  // Capienza fisica del locale (coperti per servizio). Impostala sul valore reale.
  capacity: 100,

  // Fasce orarie di servizio (default; nel codice restano sovrascrivibili da settings).
  // pranzo [inizio, taglio], cena [inizio, fine con wrap-around oltre mezzanotte],
  // pranzoCenaSplitHour = ora di taglio pranzo→cena.
  serviceWindows: { pranzo: [9, 18], cena: [18, 4], pranzoCenaSplitHour: 18 },

  // Attrezzature HACCP del nuovo ristorante (Reg. CE 852/2004). Metti le TUE
  // attrezzature/zone reali (questi sono nomi generici da personalizzare).
  //   temperatureLocations : frigoriferi/celle da monitorare (opzioni nel form)
  //   requiredLocations    : quelle con controllo temperatura GIORNALIERO obbligatorio
  //   targets              : fasce target temperatura selezionabili
  //   cleaningZones        : zone per la registrazione sanificazioni
  haccp: {
    temperatureLocations: ["Frigo 1", "Frigo 2", "Freezer", "Cella"],
    requiredLocations: ["Frigo 1", "Frigo 2", "Freezer", "Cella"],
    targets: ["0/+4", "-20/-18", "+2/+8"],
    cleaningZones: ["Cucina", "Banco", "Pavimenti", "Attrezzatura"],
  },

  // Metadati PWA / manifest / meta HTML del nuovo ristorante.
  pwa: {
    title: "Ristorante Prova",                        // <title> HTML + document.title
    manifestName: "Ristorante Prova — Gestione",      // nome installazione PWA
    shortName: "Prova",                               // nome breve icona home
    appTitle: "Prova",                                // titolo app iOS
    description: "Gestione magazzino, laboratorio e vendite — Ristorante Prova, Ancona",
    themeColor: "#1C1A17",                            // colore tema (personalizza)
    backgroundColor: "#F4F0E8",                       // colore sfondo splash (personalizza)
  },

  // Fornitore di cassa per l'import scontrini (se diverso, adatta il parser).
  importVendor: "Zucchetti TCPOS",
};

export default TENANT;
